import React, { useState } from "react";
import {
  useStripe,
  useElements,
  ExpressCheckoutElement,
} from "@stripe/react-stripe-js";
import axiosInstance from "../../../utils/Requests/axios";
import Constant from "../../Constants";

const ExpressCheckout = ({
  expressMethod,
  setExpressMethod,
  handleCartPayment,
  setShowExpressPlaceholder,
  setAvailablePaymentMethods,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState();
  const { paymentMethodTypes } = Constant();

  const onConfirm = async () => {
    if (!stripe) {
      // Stripe.js hasn't loaded yet.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      return;
    }

    // Create the PaymentIntent and obtain clientSecret
    const response = await axiosInstance.post("/cart/intent", {
      type: paymentMethodTypes[expressMethod]
    });
    const intentSecret = response?.data?.id;
    const clientSecret = response?.data?.secret;
    const orderId = response?.data?.order_uuid;

    // Confirm the PaymentIntent using the details collected by the Express Checkout Element
    const { error } = await stripe.confirmPayment({
      // `elements` instance used to create the Express Checkout Element
      elements,
      // `clientSecret` from the created PaymentIntent
      clientSecret,
      confirmParams: {
        return_url: `${process.env.REACT_APP_BASE_URL}/cart/confirmation?orderId=${orderId}`,
      },
      redirect: "if_required",
    });

    if (error) {
      // This point is only reached if there's an immediate error when
      // confirming the payment. Show the error to your customer (for example, payment details incomplete)
      setErrorMessage(error.message);
    } else {
      // The payment UI automatically closes with a success animation.
      // Your customer is redirected to your `return_url`.
      await handleCartPayment({
        type: paymentMethodTypes[expressMethod],
        secret: intentSecret,
      });
    }
  };

  const expressCheckoutOptions = {
    buttonType: {
      applePay: "plain",
      googlePay: "pay",
    },
    paymentMethods: {
      amazonPay: "never",
      link: "never",
      applePay:
        expressMethod === "check" || expressMethod === "apple"
          ? "always"
          : "never",
      googlePay:
        expressMethod === "check" || expressMethod === "google"
          ? "always"
          : "never",
    },
  };

  const onReady = ({ availablePaymentMethods }) => {
    if (!availablePaymentMethods) {
      setExpressMethod(null);
      setShowExpressPlaceholder(false);
      setAvailablePaymentMethods([]);
    } else {
      if (expressMethod === "check") {
        setExpressMethod(null);
        setAvailablePaymentMethods(availablePaymentMethods);
      }
      setShowExpressPlaceholder(false);
    }
  };

  return (
    <div id="checkout-page">
      <ExpressCheckoutElement
        options={expressCheckoutOptions}
        onConfirm={onConfirm}
        onReady={onReady}
      />
      {errorMessage && (
        <div className="text-secondary text-center">{errorMessage}</div>
      )}
    </div>
  );
};

export default ExpressCheckout;
